module.exports = __webpack_public_path__ + "static/img/yinliangjia.867c3f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/yinliangjia.png
// module id = dBNa
// module chunks = 24